export const requisitoLegalAmbitos = [
  "",
  "europea",
  "estatal",
  "autonomica",
  "local",
  "otro",
] as const;

export type RequisitoLegalAmbito = (typeof requisitoLegalAmbitos)[number];
export type BooleanFilter = "" | "si" | "no" | "pendiente";

export type RequisitoLegalAspecto = {
  id: number;
  nombre: string;
  orden: number;
  activo: boolean;
  usuario_modificacion_id: number | null;
  created_at: string | null;
  updated_at: string | null;
};

export type RequisitoLegalRow = {
  id: number;
  requisito_id: number;
  referencia_id: number;
  aspecto_id: number;
  aspecto: string;
  referencia: string;
  ambito: "europea" | "estatal" | "autonomica" | "local" | "otro";
  ambito_original: string | null;
  derogada: boolean;
  derogada_original: string | null;
  requisito: string | null;
  periodicidad: string | null;
  registro_a_obtener: string | null;
  cumplimiento: boolean | null;
  cumplimiento_original: string | null;
  observaciones: string | null;
  usuario_modificacion_id: number | null;
  created_at: string | null;
  updated_at: string | null;
};

export type RequisitoLegalControlModificacion = {
  id: number;
  fecha: string;
  modificaciones_realizadas: string;
  usuario_modificacion_id: number | null;
  created_at: string | null;
  updated_at: string | null;
};

export type RequisitoLegalFilters = {
  search: string;
  aspecto_id: string;
  ambito: string;
  derogada: BooleanFilter;
  cumplimiento: BooleanFilter;
};

export type RequisitoLegalPayload = {
  aspecto_id: number | null;
  aspecto_nombre: string;
  referencia_id: number | null;
  referencia: string;
  ambito: string;
  ambito_original: string | null;
  derogada: boolean;
  derogada_original: string | null;
  observaciones: string | null;
  requisito: string | null;
  periodicidad: string | null;
  registro_a_obtener: string | null;
  cumplimiento: boolean | null;
  cumplimiento_original: string | null;
};

export type RequisitoLegalControlModificacionPayload = {
  fecha: string;
  modificaciones_realizadas: string;
};

export type RequisitosLegalesResponse = {
  data: RequisitoLegalRow[];
  control_modificaciones: RequisitoLegalControlModificacion[];
  aspectos: RequisitoLegalAspecto[];
  meta: {
    total: number;
    counts: {
      aspectos: number;
      referencias: number;
      requisitos: number;
      control_modificaciones: number;
    };
  };
};

export const defaultRequisitoLegalFilters: RequisitoLegalFilters = {
  search: "",
  aspecto_id: "",
  ambito: "",
  derogada: "",
  cumplimiento: "",
};

export function createEmptyRequisitoLegalPayload(): RequisitoLegalPayload {
  return {
    aspecto_id: null,
    aspecto_nombre: "",
    referencia_id: null,
    referencia: "",
    ambito: "estatal",
    ambito_original: null,
    derogada: false,
    derogada_original: null,
    observaciones: "",
    requisito: "",
    periodicidad: "",
    registro_a_obtener: "",
    cumplimiento: null,
    cumplimiento_original: null,
  };
}

export function mapRowToPayload(row: RequisitoLegalRow): RequisitoLegalPayload {
  return {
    aspecto_id: row.aspecto_id,
    aspecto_nombre: row.aspecto,
    referencia_id: row.referencia_id,
    referencia: row.referencia,
    ambito: row.ambito,
    ambito_original: row.ambito_original,
    derogada: row.derogada,
    derogada_original: row.derogada_original,
    observaciones: row.observaciones ?? "",
    requisito: row.requisito ?? "",
    periodicidad: row.periodicidad ?? "",
    registro_a_obtener: row.registro_a_obtener ?? "",
    cumplimiento: row.cumplimiento,
    cumplimiento_original: row.cumplimiento_original,
  };
}
